var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { staticClass: "editarBasic", attrs: { row: "", "justify-center": "" } },
    [
      _c("v-card", { attrs: { id: "cardDivTV" } }, [
        _c("div", [
          _c(
            "div",
            { staticClass: "cardnew", attrs: { align: "center" } },
            [
              _c("br"),
              _c(
                "v-flex",
                { attrs: { md10: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "rounded-card" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" },
                          model: {
                            value: _vm.validForm,
                            callback: function($$v) {
                              _vm.validForm = $$v
                            },
                            expression: "validForm"
                          }
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _c(
                                "div",
                                { attrs: { align: "left" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between"
                                      },
                                      attrs: { md12: "" }
                                    },
                                    [
                                      _c(
                                        "h2",
                                        {
                                          staticClass: "h2_title",
                                          staticStyle: {
                                            "margin-top": "12px !important"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.esEdicion
                                                  ? "Editar Basic"
                                                  : "Ver Detalle Basic Howen"
                                              ) +
                                              "\n                    "
                                          )
                                        ]
                                      ),
                                      _vm.esEdicion
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticClass: "btn-grabar",
                                              attrs: { depressed: "" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.confirmCallbackConfirm(
                                                    true
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("Guardar Cambios")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("v-divider"),
                              _c("br"),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: { sm8: "", md8: "", "d-flex": "" }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.formFields.norm.label,
                                          items: _vm.formFields.norm.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedNorm,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.norm.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.norm,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.norm.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { sm8: "", md8: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.recordMode.label,
                                          items:
                                            _vm.formFields.recordMode.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedRecordMode,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.recordMode.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.recordMode,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.recordMode.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { sm8: "", md8: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.formFields.camType.label,
                                          items: _vm.formFields.camType.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedCamType,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.camType.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.camType,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.camType.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { sm8: "", md8: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.displayType.label,
                                          items:
                                            _vm.formFields.displayType.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedDisplayType,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.displayType.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.displayType,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.displayType.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs2: "" } },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label: "CH1",
                                          disabled: !_vm.esEdicion
                                        },
                                        model: {
                                          value: _vm.checkboxes[1],
                                          callback: function($$v) {
                                            _vm.$set(_vm.checkboxes, 1, $$v)
                                          },
                                          expression: "checkboxes[1]"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs2: "" } },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label: "CH2",
                                          disabled: !_vm.esEdicion
                                        },
                                        model: {
                                          value: _vm.checkboxes[2],
                                          callback: function($$v) {
                                            _vm.$set(_vm.checkboxes, 2, $$v)
                                          },
                                          expression: "checkboxes[2]"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs2: "" } },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label: "CH3",
                                          disabled: !_vm.esEdicion
                                        },
                                        model: {
                                          value: _vm.checkboxes[3],
                                          callback: function($$v) {
                                            _vm.$set(_vm.checkboxes, 3, $$v)
                                          },
                                          expression: "checkboxes[3]"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs2: "" } },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label: "CH4",
                                          disabled: !_vm.esEdicion
                                        },
                                        model: {
                                          value: _vm.checkboxes[4],
                                          callback: function($$v) {
                                            _vm.$set(_vm.checkboxes, 4, $$v)
                                          },
                                          expression: "checkboxes[4]"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs8: "" } },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label: "CH5",
                                          disabled: !_vm.esEdicion
                                        },
                                        model: {
                                          value: _vm.checkboxes[5],
                                          callback: function($$v) {
                                            _vm.$set(_vm.checkboxes, 5, $$v)
                                          },
                                          expression: "checkboxes[5]"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: { sm8: "", md8: "", "d-flex": "" }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.formFields.ahdType.label,
                                          items: _vm.formFields.ahdType.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedAhdType,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.ahdType.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.ahdType,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.ahdType.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.crud.editarCamara.titulo"),
          mensaje: _vm.$t("mensajes.crud.editarCamara.mensaje"),
          textoBtnSi: _vm.$t("mensajes.crud.editarCamara.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.editarCamara.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.grabarEdicion($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }